function QuoteServiceResponseTransformer(quoteResultModelBuilder, serviceResponseRepository, quoteResultModelFactory) {

	function transform(quoteResponses) {
		var quoteResults = [] ;
		quoteResponses.forEach(function(response) {
			// if ( response.quoteResult && ! response.quoteResult.errors )
			// response.productCode
			// quoteResults.push(new QuoteResultModel(response));
			quoteResults.push(quoteResultModelFactory.newQuoteResultModel(response));
		});

		var oldResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var updatedQuoteResults = updateQuoteResults(quoteResults , oldResults) ;
		var filteredQuoteResults = filterQuoteResults(updatedQuoteResults);
		return filteredQuoteResults;
	}

	function updateQuoteResults(currentResults, oldResults) {
		if ( ! oldResults || oldResults.length == 0 )
			return currentResults ;

		currentResults.forEach(function(cqr) {
			if ( cqr.isCoverAvailable ) {
				addOrUpdateQuoteResult(oldResults, cqr)
			} else {
				oldResults = removeAllCoverTypeMatches(oldResults, cqr) ;
			}
		});

		return oldResults ;
	}

	function addOrUpdateQuoteResult(oldResults, quoteResult) {
		var matchingOldResult = findCompleteMatch(oldResults, quoteResult) ;
		if ( matchingOldResult ) {
			var oldResultIndex = oldResults.indexOf(matchingOldResult) ;
			oldResults[oldResultIndex] = quoteResult ;
		} else {
			oldResults.push(quoteResult);
		}
	}

	function removeAllCoverTypeMatches(oldResults, quoteResult) {
		var partialMatches = findCoverTypeMatches(oldResults, quoteResult) ;
		if ( partialMatches ) {
			oldResults = oldResults.filter(function(qr) {
				return partialMatches.indexOf(qr) === -1 ;
			}) ;
		}
		return oldResults;
	}

	function findCoverTypeMatches(oldResults, quoteResult) {
		var matchingQuoteResponses = [] ;
		oldResults.forEach(function(qr) {
			if ( qr.coverType == quoteResult.coverType
			&& (!qr.offering || qr.offering == quoteResult.offering) ){
				matchingQuoteResponses.push(qr);
			}
		});
		return matchingQuoteResponses;
	}

	function findCompleteMatch(oldResults, quoteResult) {
		var matchingQuoteResponse = null ;
		oldResults.some(function(qr) {
			if ( qr.coverType == quoteResult.coverType
				&& qr.paymentFrequency == quoteResult.paymentFrequency 
				&& (!qr.offering || qr.offering == quoteResult.offering)
				){
				matchingQuoteResponse = qr;
				return true;
			}
		});
		return matchingQuoteResponse;
	}

	function filterQuoteResults(quoteResults) {
		quoteResults = quoteResults.filter(function(qr) {
			return qr.isCoverAvailable;
		})

		return quoteResults ;
	}

	return {
		transform: transform,
	}
}
